import { matchResultsSharePath, ROUTES } from '../../../constants/routes';
import { resolveSiteOriginString } from '../../../lib/siteOrigin';

function siteOrigin(): string | null {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return resolveSiteOriginString();
}

/**
 * Absolute URL for the public match-results page (`/match/:matchResultsId`).
 * Used for social share, email, and "view in browser" links.
 */
export function getMatchResultsPublicUrl(
  matchResultsId: string | null | undefined,
): string {
  const id = matchResultsId?.trim();
  if (!id) {
    const origin = siteOrigin();
    return origin ? `${origin}${ROUTES.matchingPoc}` : ROUTES.matchingPoc;
  }
  const path = matchResultsSharePath(id);
  const origin = siteOrigin();
  return origin ? `${origin}${path}` : path;
}

/**
 * @deprecated Use {@link getMatchResultsPublicUrl} with `matchResultsId` from POST /match.
 */
export function getMatchResultsSharePlaceholderUrl(): string {
  return getMatchResultsPublicUrl(undefined);
}
